import {
  array,
  boolean,
  literal,
  number,
  object,
  optional,
  string,
  union,
} from 'zod';

export const BuildLearningMaterialSchema = object({
  isLearningMaterialEnabled: boolean(),
  materials: array(
    object({
      type: union([literal('FILE'), literal('WEB'), literal('YOUTUBE')]),
      url: string(),
      originalFileName: optional(string()),
      allowReopenDuringPlay: boolean(),
      fileSize: number(),
    }),
  ),
});

export const getBuildLearningMaterialSchema = () => {
  return BuildLearningMaterialSchema;
};
